import { createFileRoute, redirect } from "@tanstack/react-router";
import MyCardsPage from "@/site/pages/my-cards";
import { isMyCardsTab } from "@/site/components/my-cards/my-cards-data";

// Old app's My Cards lived at /mycards/:myCardsType — keep the URL shape.
export const Route = createFileRoute("/mycards/$type")({
  beforeLoad: ({ params }) => {
    if (!isMyCardsTab(params.type)) {
      throw redirect({ to: "/mycards/$type", params: { type: "upcoming" } });
    }
  },
  // `?card_send_id=` — a "your card is scheduled" / CARD DETAILS email link (legacy
  // `card_scheduled` carries the numeric legacy id; ours the uuid). A full session on
  // Upcoming/Sent gets the legacy pinned "Recently viewed" row with its details dialog
  // open; a SOFT session sees only that card (PRD 08 D18a).
  // `?copy_read=<read_slug>` — legacy `/copy/read/<magic>` (GET LINK): the Send by Link
  // dialog over the Sent tab.
  // `?contact_id=` — My Contacts' "Cards Sent" (legacy `?address_book_id=`): the outbox
  // tabs show only sends to that contact, under a dismissible "Showing cards sent to …".
  validateSearch: (
    search: Record<string, unknown>,
  ): { card_send_id?: string; contact_id?: string; copy_read?: string } => ({
    copy_read:
      typeof search.copy_read === "string" && /^[A-Za-z0-9_-]{1,40}$/.test(search.copy_read)
        ? search.copy_read
        : undefined,
    contact_id:
      typeof search.contact_id === "string" && /^[A-Za-z0-9-]{1,40}$/.test(search.contact_id)
        ? search.contact_id
        : undefined,
    card_send_id:
      typeof search.card_send_id === "string" && /^[A-Za-z0-9-]{1,40}$/.test(search.card_send_id)
        ? search.card_send_id
        : typeof search.card_send_id === "number"
          ? String(search.card_send_id)
          : undefined,
  }),
  component: MyCardsPage,
});
